module.exports = __webpack_public_path__ + "static/WFOE-3fda8dc93138999ed3d7d370e5266722.jpg";